import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell, ResponsiveContainer } from 'recharts';
import { Expense } from '@/types/expense';
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";

interface PaymentBarChartProps {
  expenses: Expense[];
}

const PAYMENT_COLORS = ['#22c55e', '#f59e0b', '#ef4444'];

export const PaymentBarChart = ({ expenses }: PaymentBarChartProps) => {
  const originalExpenses = expenses.filter(expense => !expense.description.includes('(Split'));
  
  const participantPayments = originalExpenses.reduce((acc, expense) => {
    if (expense.paidBy) {
      acc[expense.paidBy] = (acc[expense.paidBy] || 0) + Number(expense.amount);
    }
    return acc;
  }, {} as Record<string, number>);

  const paymentData = Object.entries(participantPayments).map(([name, amount]) => ({
    name,
    amount,
    color: PAYMENT_COLORS[0]
  }));

  return (
    <ScrollArea className="w-full h-full">
      <div className="min-w-[300px] md:min-w-[600px] h-[400px] p-4">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart 
            data={paymentData} 
            layout="vertical" 
            className="bg-gradient-to-br from-white/95 to-white/90 backdrop-blur-sm rounded-lg shadow-lg"
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="number" unit="₹" />
            <YAxis dataKey="name" type="category" width={100} />
            <Tooltip
              formatter={(value: number) => `₹${value.toFixed(2)}`}
              contentStyle={{
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                borderRadius: '8px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}
            />
            <Bar
              dataKey="amount"
              fill="#8884d8"
              radius={[0, 4, 4, 0]}
              label={{ position: 'right', formatter: (value: number) => `₹${value.toFixed(0)}` }}
            >
              {paymentData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={PAYMENT_COLORS[index % PAYMENT_COLORS.length]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
      <ScrollBar orientation="horizontal" />
    </ScrollArea>
  );
};